import { inventoryDuckCreator } from 'axl-ducks';

import { srpDuckPreset } from '@/ducks/presets/index.js';

export default inventoryDuckCreator({
    ...srpDuckPreset,
});
